var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var stdin_exports = {};
__export(stdin_exports, {
  joinPath: () => joinPath,
  splitPath: () => splitPath,
  toPathParts: () => toPathParts
});
module.exports = __toCommonJS(stdin_exports);
var import_string = require("./string");
function splitPath(dataPath, noThrow) {
  const ans = [];
  let path = String(dataPath);
  let expectDot = false;
  while (path) {
    let mat;
    if (mat = /^\s+/.exec(path)) {
    } else if (mat = /^\[\s*("(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*'|-?\d+)\s*\]/.exec(path)) {
      const p = mat[1];
      if (p[0] === '"' || p[0] === "'") {
        ans.push((0, import_string.unescapeString)(p.slice(1, -1)));
      } else {
        const n = parseInt(p, 10);
        if (isNaN(n))
          throw new Error(`Invalid index number: ${path}`);
        ans.push(String(n));
      }
      expectDot = true;
    } else if (expectDot && (mat = /^\??\./.exec(path))) {
      expectDot = false;
    } else if (!expectDot && (mat = /^[^[\]\s.]+/.exec(path))) {
      ans.push(mat[0]);
      expectDot = true;
    } else {
      if (noThrow)
        return null;
      throw new Error(`Unknown remainder: ${path}`);
    }
    path = path.slice(mat[0].length);
  }
  return ans;
}
function joinPath(parts) {
  let ans = parts.map((x) => {
    if (!Number.isNaN(+x))
      return `[${x}]`;
    if (!x)
      return "";
    if (/^[a-zA-Z\d_$][\w$]*$/.test(x))
      return `.${x}`;
    return `[${JSON.stringify(String(x))}]`;
  }).join("");
  if (ans.charAt(0) === ".")
    ans = ans.substr(1);
  return ans;
}
function toPathParts(input) {
  if (typeof input === "number")
    return [String(input)];
  if (Array.isArray(input))
    return Array.from(input, (x) => String(x));
  return splitPath(input);
}
